export default __webpack_public_path__ + "static/media/CasalK.ba1bbd4e.png";